import vars from '../helpers';
import helpers from "../helpers";
import Vivus from 'vivus';

function homeAnimation(animation = 'open', $item, $next, status) {

	let tl = gsap.timeline();

	switch (animation) {
		case 'open':
			tl
				.from('.home-tickets__front', {
					delay: 0.8,
					stagger: 0.2,
					onStart() {
						$('.header').addClass('is-intro');
						$('.home-tickets__front').addClass('is-intro');
						$('.home-tickets__back').addClass('is-intro');
						$('.home-tickets__circle').addClass('is-intro');

						$('.home-main-footer__text').addClass('is-intro');
						$('.home-main-footer__img-wrapper').addClass('is-intro');
						$('.home-tickets__btn').addClass('is-intro');
					},
				})

			break;

		default:
			break;
	}
}

function clickTeam() {
	$('.js-team-btn').on('click', function () {
		$('.footer-team-info').addClass('active');
	});

	$('.footer-team-info__close').on('click', function () {
		$('.footer-team-info').removeClass('active');
	});
}

function scrollMenu() {
	if( $(window).width() <= 1024 ) {
		$(window).scroll(function(){

			var offsetFromScreenTop0 = $("#home-video").offset().top - $(window).scrollTop() - $('.home-menu').height() ;
			if(offsetFromScreenTop0 <= 0) {
				$('.home-menu').addClass('active');
			} else {
				$('.home-menu').removeClass('active');
			}


			var offsetFromScreenTop1 = $("#home-video").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop1 <= 0 && offsetFromScreenTop1 > (-$('#home-video').height())) {
				$('.home-menu__item.el-1').addClass('active');
			} else if ( offsetFromScreenTop1 < (-$('#home-video').height()) ) {
				$('.home-menu__item.el-1').removeClass('active');
			} else {
				$('.home-menu__item.el-1').removeClass('active');
			}

			var offsetFromScreenTop2 = $("#home-accordion").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop2 <= 0 && offsetFromScreenTop2 > (-$('#home-accordion').height())) {
				$('.home-menu__item.el-2').addClass('active');
			} else if ( offsetFromScreenTop2 < (-$('#home-accordion').height()) ) {
				$('.home-menu__item.el-2').removeClass('active');
			} else {
				$('.home-menu__item.el-2').removeClass('active');
			}

			var offsetFromScreenTop3 = $("#home-article").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop3 <= 0 && offsetFromScreenTop3 > (-$('#home-article').height())) {
				$('.home-menu__item.el-3').addClass('active');
			} else if ( offsetFromScreenTop3 < (-$('#home-article').height()) ) {
				$('.home-menu__item.el-3').removeClass('active');
			} else {
				$('.home-menu__item.el-3').removeClass('active');
			}
		});
	} else {
		$(window).scroll(function(){
			var offsetFromScreenTop1 = $("#home-video").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop1 <= 0 && offsetFromScreenTop1 > (-$('#home-video').height())) {
				$('.home-menu__item.el-1').addClass('active');
			} else if ( offsetFromScreenTop1 < (-$('#home-video').height()) ) {
				$('.home-menu__item.el-1').removeClass('active');
			} else {
				$('.home-menu__item.el-1').removeClass('active');
			}

			var offsetFromScreenTop2 = $("#home-accordion").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop2 <= 0 && offsetFromScreenTop2 > (-$('#home-accordion').height())) {
				$('.home-menu__item.el-2').addClass('active');
			} else if ( offsetFromScreenTop2 < (-$('#home-accordion').height()) ) {
				$('.home-menu__item.el-2').removeClass('active');
			} else {
				$('.home-menu__item.el-2').removeClass('active');
			}

			var offsetFromScreenTop3 = $("#home-article").offset().top - $(window).scrollTop() - ($(window).height() / 2);
			if(offsetFromScreenTop3 <= 0 && offsetFromScreenTop3 > (-$('#home-article').height())) {
				$('.home-menu__item.el-3').addClass('active');
			} else if ( offsetFromScreenTop3 < (-$('#home-article').height()) ) {
				$('.home-menu__item.el-3').removeClass('active');
			} else {
				$('.home-menu__item.el-3').removeClass('active');
			}

		});
	}
}

function animationLine(svgLine) {
	let checkBookTrigger = true;

	function triggerVisus() {
		console.log(svgLine);
		$(window).scroll(function(){
			var offsetFromScreenTop = $(svgLine).offset().top - $(window).scrollTop() - ($(window).height());

			if (offsetFromScreenTop <= 0 && checkBookTrigger) {
				checkBookTrigger = false;

				let $el1 = $(svgLine).find('svg');

				$el1.each((index, el) => {
					$(svgLine).removeClass('is-hide');
					let graphVivus = new Vivus(el,
						{
							type: 'oneByOne',
							duration: 150,
							reverseStack: true,
							animTimingFunction: Vivus.EASE,
						},
					);
				});
			}
		})
	}
	triggerVisus();
}

let pos1 = $('.home-accordion__item.el-1.accordion__item').height();
let pos2 = $('.home-accordion__item.el-2.accordion__item').height();
let pos3 = $('.home-accordion__item.el-3.accordion__item').height();


setTimeout(function () {
	pos1 = $('.home-accordion__item.el-1.accordion__item').height();
	pos2 = $('.home-accordion__item.el-2.accordion__item').height();
	pos3 = $('.home-accordion__item.el-3.accordion__item').height();
}, 1000);

function anchorScroll() {
	let heightHeader = 0;
	if( $(window).width() <= 1024 ) {
		heightHeader = $('.home-menu').height();
	}

	$('.js-anchor').on('click', function (e) {
		let anchor = $(this);
		$('body, html').stop().animate({
			scrollTop: $(anchor.attr('data-anchor')).offset().top - heightHeader,
		}, 800);
		e.preventDefault();
	});
}

function accordionInit() {
	/*=============== ACCORDION ===============*/
	const accordionItems = document.querySelectorAll('.accordion__item');
	let heightHeader = 0;
	if( $(window).width() <= 1024 ) {
		heightHeader = $('.home-menu').height();
	}

// 1. Selecionar cada item
	accordionItems.forEach((item) =>{
		const accordionBtn = item.querySelector('.home-accordion-header__btn')

		// 2. Seleccionar cada click del header
		accordionBtn.addEventListener('click', () =>{
			// 7. Crear la variable
			const openItem = document.querySelector('.accordion-open')




			// 8. Validar si existe la clase
			if(openItem && openItem!== item){
				toggleItem(openItem)
			}

			// 5. Llamar a la funcion toggle item
			toggleItem(item)

			let pos = $('.home-accordion__list').offset().top;
			let posMain = $('.home-accordion__list').offset().top;

			if( $(item).attr('data-id') == 1) {
				pos = posMain - heightHeader;
			} else if( $(item).attr('data-id') == 2 ) {
				pos = posMain + pos1 - heightHeader;
			} else if( $(item).attr('data-id') == 3 ) {
				pos = posMain + pos1 + pos2 - heightHeader;
			}

			console.log(heightHeader);

			$('body, html').stop().animate({
				scrollTop: pos,
			}, 400);
		})
	})

// 3. Crear una funcion tipo constante
	const toggleItem = (item) =>{
		// 3.1 Crear la variable
		const accordionContent = item.querySelector('.accordion__content')

		// 6. Si existe otro elemento que contenga la clase accorion-open que remueva su clase
		if(item.classList.contains('accordion-open')){
			accordionContent.removeAttribute('style');
			item.classList.remove('accordion-open');
			$(item).find('span').text('читать');

			$('.home-background__line').removeClass('type-1');
			$('.home-background__line').removeClass('type-2');
			$('.home-background__line').removeClass('type-3');
		}else{
			// 4. Agregar el height maximo del content
			accordionContent.style.height = accordionContent.scrollHeight + 15 + 'px';
			$(item).find('span').text('свернуть');
			item.classList.add('accordion-open');

			if( $(item).attr('data-id') == 1) {
				$('.home-background__line').addClass('type-1');
				$('.home-background__line').removeClass('type-2');
				$('.home-background__line').removeClass('type-3');

				animationLine('.js-svg-4');
			} else if( $(item).attr('data-id') == 2 ) {
				$('.home-background__line').removeClass('type-1');
				$('.home-background__line').addClass('type-2');
				$('.home-background__line').removeClass('type-3');

				animationLine('.js-svg-5');
			} else if( $(item).attr('data-id') == 3 ) {
				$('.home-background__line').removeClass('type-1');
				$('.home-background__line').removeClass('type-2');
				$('.home-background__line').addClass('type-3');

				animationLine('.js-svg-6');
			}
		}
	}
}

function introAnimation() {
	$('.home__pink-line--1').addClass('is-intro');
	$('.home-intro__title .el-1').addClass('is-intro');
	$('.home-intro__title .el-2').addClass('is-intro');
	$('.home-intro__title .el-3').addClass('is-intro');
	$('.home-intro__desc').addClass('is-intro');
	$('.home-intro__desc').addClass('is-intro');
	$('.home-intro__img--2').addClass('is-intro');
	$('.home-intro__img--1 .home-intro__img').addClass('is-intro');
	$('.home-intro-menu__title').addClass('is-intro');
	$('.home-intro-menu__item').addClass('is-intro');

	setTimeout(function (){
		let svgLine = '.js-svg-2';
		let $el1 = $(svgLine).find('svg');

		$el1.each((index, el) => {
			$(svgLine).removeClass('is-hide');
			let graphVivus = new Vivus(el,
				{
					type: 'oneByOne',
					duration: 150,
					reverseStack: true,
					animTimingFunction: Vivus.EASE,
				},
			);
		});
	}, 3200)

	setTimeout(function (){
		let svgLine = '.js-svg-3';
		let $el1 = $(svgLine).find('svg');

		$el1.each((index, el) => {
			$(svgLine).removeClass('is-hide');
			let graphVivus = new Vivus(el,
				{
					type: 'oneByOne',
					duration: 150,
					reverseStack: true,
					animTimingFunction: Vivus.EASE,
				},
			);
		});
	}, 3800)
}

function init(container, isFirst) {

	accordionInit();
	scrollMenu();
	anchorScroll();
	introAnimation();
	animationLine('.js-svg-1');

	if( $(window).width() <= 1024 ) {
		clickTeam();
	} else {

	}

	setTimeout(function () {
		AOS.init({
			once: true,
			duration: 1500,
		});

		console.log('AOS');
	}, 500);
}

function destroy(container) {
}

export default {
	init,
	destroy,
};
